import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIconAmex, LazyIconArrowsUpDownRounded, LazyIconBarChart, LazyIconBattery, LazyIconCalendar, LazyIconCardNetworks, LazyIconCard, LazyIconCart2, LazyIconCartIconOnepass, LazyIconCheckRoundedRedSolid, LazyIconCheckRoundedRed, LazyIconCheckRounded, LazyIconCheck, LazyIconClose, LazyIconCode, LazyIconFlybuys, LazyIconHome, LazyIconLocation, LazyIconLogout, LazyIconMastercard, LazyIconMenu, LazyIconPayments, LazyIconPenGreySolid, LazyIconPerson, LazyIconPhoneRounded, LazyIconPhone, LazyIconPin, LazyIconPlaneRounded, LazyIconPlay, LazyIconPlusRounded, LazyIconReloadRed, LazyIconReturn, LazyIconSim, LazyIconTrashGreySolid, LazyIconVisa, LazyIconWarning } from '#components'
const lazyGlobalComponents = [
  ["IconAmex", LazyIconAmex],
["IconArrowsUpDownRounded", LazyIconArrowsUpDownRounded],
["IconBarChart", LazyIconBarChart],
["IconBattery", LazyIconBattery],
["IconCalendar", LazyIconCalendar],
["IconCardNetworks", LazyIconCardNetworks],
["IconCard", LazyIconCard],
["IconCart2", LazyIconCart2],
["IconCartIconOnepass", LazyIconCartIconOnepass],
["IconCheckRoundedRedSolid", LazyIconCheckRoundedRedSolid],
["IconCheckRoundedRed", LazyIconCheckRoundedRed],
["IconCheckRounded", LazyIconCheckRounded],
["IconCheck", LazyIconCheck],
["IconClose", LazyIconClose],
["IconCode", LazyIconCode],
["IconFlybuys", LazyIconFlybuys],
["IconHome", LazyIconHome],
["IconLocation", LazyIconLocation],
["IconLogout", LazyIconLogout],
["IconMastercard", LazyIconMastercard],
["IconMenu", LazyIconMenu],
["IconPayments", LazyIconPayments],
["IconPenGreySolid", LazyIconPenGreySolid],
["IconPerson", LazyIconPerson],
["IconPhoneRounded", LazyIconPhoneRounded],
["IconPhone", LazyIconPhone],
["IconPin", LazyIconPin],
["IconPlaneRounded", LazyIconPlaneRounded],
["IconPlay", LazyIconPlay],
["IconPlusRounded", LazyIconPlusRounded],
["IconReloadRed", LazyIconReloadRed],
["IconReturn", LazyIconReturn],
["IconSim", LazyIconSim],
["IconTrashGreySolid", LazyIconTrashGreySolid],
["IconVisa", LazyIconVisa],
["IconWarning", LazyIconWarning],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
